import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = { debounce: { type: Number, default: 300 } }

  connect() {
    this._timeout = null
  }

  submit() {
    if (this._timeout) clearTimeout(this._timeout)
    this._timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, this.debounceValue)
  }

  clear() {
    if (this.hasInputTarget) {
      this.inputTarget.value = ""
      this.element.requestSubmit()
    }
  }
}
